import Vue from 'vue';
import { Route } from 'vue-router';

// Route components imported this way are lazy-loaded, for performance
// tslint:disable:max-line-length space-in-parens
const AddEditPartnerPage = () => import(/* webpackChunkName: "protected" */ '@/router/views/AddEditPartnerPage.vue');
const OpportunitiesPage = () => import(/* webpackChunkName: "protected" */ '@/router/views/OpportunitiesPage.vue');
const OrderEntryPage = () => import(/* webpackChunkName: "protected" */ '@/router/views/OrderEntryPage.vue');
const PartnersPage = () => import(/* webpackChunkName: "protected" */ '@/router/views/PartnersPage.vue');
const StyleGuidePage = () => import(/* webpackChunkName: "protected" */ '@/router/views/StyleGuidePage.vue');
const Route401 = () => import(/* webpackChunkName: "errpages" */ '@/router/views/401.vue');
const Route404 = () => import(/* webpackChunkName: "errpages" */ '@/router/views/404.vue');
// tslint:enable:max-line-length space-in-parens

export default [
	{
		name: 'home',
		path: '/',
		redirect: '/opportunities',
	},
	{
		name: 'old-login-redirect',
		path: '/Security*',
		redirect: '/opportunities',
	},
	// Handle the redirect from Okta using the Okta Vue SDK
	{
		name: 'auth-callback',
		path: '/authorized',
		// To use built-in callback, which doesn't handle errors very well
		// component: Auth.handleCallback(),
		// To use custom error handler
		component: Vue.extend({
			name: 'AuthCallback',
			async beforeMount() {
				try {
					await this.$auth.handleAuthentication();
					// If you get this far, you can extract the tokens from $auth and put in store,
					// prep axios calls, etc.
					this.$router.push({
						path: this.$auth.getFromUri(),
					});
				} catch (e) {
					this.$router.push({
						name: 'auth-error',
						params: {
							errorCode: e.errorCode ? `${e.errorCode}` : 'implicit_callback',
							message: e.message ? `${e.message}` : '',
						},
					});
					throw e;
				}
			},
			render(h) { return h(); },
		}),
	},
	// Handle error redirects from Okta login errors
	{
		name: 'auth-error',
		path: '/auth-error',
		component: Route401,
		props: (route: Route) => {
			const props = {
				code: '',
				message: '',
			};
			if (!route.params) return props;
			const params = route.params;
			if (params.errorCode) props.code = params.errorCode;
			if (params.code) props.code = params.code;
			if (params.message) props.message = params.message;
			return props;
		},
		meta: {
			requiresAuth: false,
		},
	},
	{
		name: 'old-opportunities-redirect',
		path: '/rptNISOpportunity*',
		redirect: '/opportunities',
	},
	{
		name: 'opportunities',
		path: '/opportunities',
		component: OpportunitiesPage,
		props: true,
		meta: {
			requiresAuth: true,
		},
	},
	{
		name: 'order-entry',
		path: '/order-entry/:opportunityId?',
		component: OrderEntryPage,
		props: true,
		meta: {
			requiresAuth: true,
		},
	},
	{
		name: 'old-partners-redirect',
		path: '/Partner/*',
		redirect: '/partners',
	},
	{
		name: 'partners',
		path: '/partners',
		component: PartnersPage,
		props: true,
		meta: {
			requiresAuth: true,
			requiresRole: 'AppRole-PartnerAuth-SuperAdmin',
		},
	},
	{
		name: 'add-partner',
		path: '/partners/add-partner',
		component: AddEditPartnerPage,
		props: true,
		meta: {
			requiresAuth: true,
			requiresRole: 'AppRole-PartnerAuth-SuperAdmin',
		},
	},
	{
		name: 'edit-partner',
		path: '/partners/edit-partner',
		component: AddEditPartnerPage,
		props: true,
		meta: {
			requiresAuth: true,
			requiresRole: 'AppRole-PartnerAuth-SuperAdmin',
		},
	},
	{
		name: 'style-guide',
		path: '/style-guide',
		component: StyleGuidePage,
		props: true,
		meta: {
			requiresAuth: true,
		},
	},
	{
		name: '404',
		path: '/404',
		component: Route404,
		// Allows props to be passed to the 404 page through route
		// params, such as `resource` to define what wasn't found.
		props: true,
	},
	// Redirect any unmatched routes to the 404 page. This may
	// require some server configuration to work in production:
	// https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
	{
		path: '*',
		redirect: '404',
	},
];
